<template>
	<div class="table-responsive">
		<table class="table table-hover">
			<thead>
			<tr>
				<template v-for="(header,index) in headers">
					<th class="text-center"
						v-tooltips-enabled="{
							active:true,
							title:header.title
						}">
						<i class="material-icons">{{index}}</i>
					</th>
				</template>
			</tr>
			</thead>
			<tbody>
			<tr v-for="sale_content in sale_contents"
				:class="{
					'table-warning':sale_content.checked_in
				}"
			>
<!--				date created for cache-->
				<th scope="row" class="text-nowrap">
					{{getDateFormatted(sale_content.created_at)}}
				</th>
				<th scope="row">
					<a target="_blank" :href="getUserSaleLink(sale_content)">
						{{sale_content.sale_content_reference}}
					</a>
				</th>
				<td class="graceful-text">{{getUserName(sale_content)}}</td>
				<td v-if="getUserEmail(sale_content)!==null" class="graceful-text">
					<a target="_blank" :href="'mailto:'+getUserEmail(sale_content)">
						{{getUserEmail(sale_content)}}
					</a>
				</td>
				<td v-else>

				</td>
				<td v-if="getUserTelephone(sale_content)!==null">
					<a :href="'tel:'+getUserTelephone(sale_content)" class="text-nowrap">
						{{getUserTelephone(sale_content)}}
					</a>
				</td>
				<td v-else>

				</td>
<!--				plates-->
				<td data-ref="plates">
					<template v-if="sale_content.entity_type === 'car-park'">
						<button class="btn btn-sm btn-secondary"
								v-on:click="showUserPlates(sale_content)">Plates
						</button>
						<div class="position-absolute">
							<simple-modal
									v-if="view_plates_sale_content === sale_content">
								<h3 slot="header" class="h3-responsive">
									Plates of {{getUserName(sale_content)}}
								</h3>
								<div slot="body">
									<plates
											:read="asset_read"
											:store="asset_store"
											:delete="asset_delete"
											:user_id="String(getUserId(sale_content))"
											:user_assets_group_id="getUserAssetsGroupIdId(sale_content)"
									></plates>
								</div>
								<div slot="footer">
									<span class="cursor-pointer mr-5"
										  v-on:click="closePlateView()">Close</span>
								</div>
							</simple-modal>
						</div>
					</template>
					<div v-else class="text-center text-uppercase" v-html="getTicketIcon(sale_content.entity_type)">
					</div>

				</td>
				<td v-if="sale_content.checked_in"
					class="text-nowrap cursor-zoom-in">
					<div v-on:click="getCheckedInDataForRecord(sale_content.app_sale_content_id)">
						{{getDateFormatted(sale_content.updated_at)}}
					</div>
				</td>
				<td class="text-center cursor-zoom-in" v-else
					v-on:click="getCheckedInDataForRecord(sale_content.app_sale_content_id)">
					<i class="material-icons">search</i>
				</td>
<!--				Check in history-->
				<simple-modal v-if="checkin_data_app_sale_content_id === sale_content.app_sale_content_id">
					<h3 slot="header"
						class="h3-responsive">
						Check in history for {{getUserName(sale_content)}}
					</h3>
					<div slot="body">
						<template v-if="checkin_data_loading">
							<div class="progress md-progress primary-color-dark">
								<div class="indeterminate"></div>
							</div>
						</template>
						<template v-else>
							<div class="container" v-for="check in getCheckinDataAssets" :data-ref="'len:'+getCheckinDataAssets.length">
								<div class="row" :class="check.status_class">
									<div class="text-right text-sm-left col-12 col-sm-6">
										<div class="py-2">{{check.staff}}</div>
									</div>
									<div class="text-right col-12 col-sm-6">
										<div class="py-2 font-weight-bold">{{check.date}}</div>
									</div>
								</div>
								<div class="row pb-3"
									 :class="check.status_class">
									<div class="col-12 col-sm-6">
										<div :class="check.plate_class">{{check.plate}}</div>
									</div>
									<div class="text-center text-sm-right col-12 col-sm-6 align-self-center">
										<h3 class="py-2 text-uppercase px-0">
											<span class="d-inline d-sm-none">Checked</span>
											<span>{{check.status?'in':'out'}}</span>
										</h3>
									</div>
								</div>
								<hr>
							</div>
							<div v-if="getCheckinDataAssets.length <= 0">

								<h3 class="py-2 text-uppercase px-0">
									Not Checked In
								</h3>
							</div>
						</template>

					</div>
					<div slot="footer">
						<span class="cursor-pointer mr-5" v-on:click="closeCheckInData()">Close</span>
					</div>
				</simple-modal>
			</tr>
			</tbody>
		</table>


		<!--modal for user plates-->
		<section v-if="view_plates_sale_content != null"></section>
	</div>
</template>

<script>
	import Vue from "vue";
	import {getDate, DATE_FORMAT} from "../../../../../app/Shared/Resources/Assets/js/helpers/format.date";
import vueTooltip from "../../../../../app/Shared/Resources/Assets/js/components/base/tooltip/vueTooltip";

	Vue.component('plates', require('../../../../../app/Shared/Resources/Assets/js/components/Plates'));
	Vue.component('simple-modal',
		require('../../../../../app/Shared/Resources/Assets/js/components/notifications/SimpleModal'));
	Vue.use(vueTooltip);
	export default {
		name: "CheckinList",
		propsOld: [
			'sale_contents',
			'sale_reference_uri',
			'asset_read',
			'asset_store',
			'asset_delete',
			'sale_content_checkin_read_url',
			'sale_content_checkin_post_url',
		],
		props:{
			event_id:Number,
			sale_contents:[] | Array,
			sale_reference_uri:String,
			asset_read:String,
			asset_store:String,
			asset_delete:String,
			sale_content_checkin_read_url:String,
			sale_content_checkin_post_url:String,
		},
		data(){
			return {
				view_plates_sale_content: null,
				headers:{
					access_time:{
						title:'Date inserted into app'
					},
					view_week:{
						title:'Ticket reference found on email for the individual ticket'
					},
					account_circle:{
						title:'Customer name'
					},
					email:{
						title:'Click to contact via email address'
					},
					phone:{
						title:'Click to call customer'
					},
					directions_car:{
						title:'Ticket type purchased'
					},
					playlist_add_check:{
						title:'If a date is set then the customer has claimed/ used this ticket'
					},
				},
				ticketIcons:{
					'door-ticket':{
						icon:'home',
						color:'text-primary'
					},
					'bus':{
						icon:'directions_bus',
						color:'text-success'
					},
					'addon':{
						icon:'local_pizza',
						color:'text-info'
					},
				},
				checkin_data:null,
				checkin_data_app_sale_content_id:null,
				checkin_data_loading:false,
			}
		},
		computed:{
			getCheckinDataAssets(){
				let self = this;
				let data = [];
				if(self.checkin_data === null){
					return [];
				}
				for (let i = 0; i < self.checkin_data.length; i++) {
					let checkinDatum = self.checkin_data[i];
					let checkin_type = checkinDatum.app_record_data.plate === '' ? 'ticket' : 'Plate';
					// console.log('checkinDatum.app_record_data',checkinDatum.app_record_data)
					data.push({
						date:	getDate(checkinDatum.created_at,DATE_FORMAT.date_time.short),
						staff:	checkinDatum.user.name,
						type:	checkin_type,
						plate_class:checkinDatum.app_record_data.plate !== '' ? 'plate w-100' : '',
						plate:	checkinDatum.app_record_data.plate !== '' ? checkinDatum.app_record_data.plate : 'Ticket',
						status:	checkinDatum.value > 0 ,
						status_class: checkinDatum.value > 0 ? 'bg-warning' : ''
					});
				}
				return data;

			}
		},
		methods: {
			getTicketIcon(ticket){
				let self = this;

				if(!self.ticketIcons.hasOwnProperty(ticket)){
					return `<i class="material-icons text-grey">remove</i>`;
				}
				return `<i class="material-icons ${self.ticketIcons[ticket].color}">${self.ticketIcons[ticket].icon}</i>`;
			},
			closeCheckInData(){
				let self = this;
				self.checkin_data_app_sale_content_id = null;
				self.checkin_data = null;
			},
			getCheckedInDataForRecord(app_sale_content_id){
				let self = this;
				self.checkin_data_app_sale_content_id = app_sale_content_id;
				self.checkin_data_loading = true;

				let axios_data = {
					app_sale_content_id:app_sale_content_id,
					event_id:self.event_id
				};

				axios
						.post(self.sale_content_checkin_read_url, axios_data)
						/**
						 * @param {Object} response
						 */
						.then(function (response) {
							if(response.data.success === true){
								self.checkin_data = response.data.data;
							}
						})
						.catch(function (e) {
							// catch error if any
							console.error('events fetch', e);
						})
						.then(function () {
							// always executed
							self.checkin_data_loading = false;
						});
			},
			getDateFormatted(date){
							return getDate(date,DATE_FORMAT.date_time.short)
			},
			getUserSaleLink(sale_content) {
				// console.log('sale_content',sale_content)
				let id = sale_content.sale_content_id;
				let splitString = this.sale_reference_uri.split('/'),
					len = splitString.length - 1;
				// get last elements
				let lastElm = splitString[len];
				if (lastElm == 'id') {
					splitString[len] = id;
				}
				// console.log('getUserSaleLink', 'splitString.join(/)',splitString.join('/'));
				return splitString.join('/');
			},
			getUserId(sale_content) {
				// console.log('getUserId', 'sale_content', sale_content);
				return sale_content.asset_user_id || null;
			},
			getUserAssetsGroupIdId(sale_content) {
				// console.log('getUserId', 'sale_content', sale_content);
				return sale_content.user_assets_group_id || null;
			},
			getUserName(sale_content) {
				return sale_content.user_full_name;
			},
			getUserEmail(sale_content) {
				return sale_content.user_email || ''
			},
			getUserTelephone(sale_content) {
				if (sale_content.vip_reservation) {
					return sale_content.asset_user_telephone || '';
				} else {
					return sale_content.user_telephone || '';
				}
			},
			getUserPlates(sale_content) {
				let plates = [];

				sale_content.user_assets_group.user_assets.forEach(function (asset) {
					if (asset.type === 'plate') {
						plates.push(asset.value);
					}
				});

				return plates;
			},

			closePlateView() {
				this.view_plates_sale_content = null;
			},
			showUserPlates(sale_content) {
				this.view_plates_sale_content = sale_content;
				// this.$nextTick(function () {
				// 	$('#platesEditingModel').modal('toggle');
				// });
			},
		},
	}
</script>

<style scoped>
	.graceful-text:hover{
		max-width: 250px;
	}
	.graceful-text{
		max-width: 150px;
		overflow: hidden;
		white-space: nowrap !important;
		text-overflow: ellipsis;
		padding: 5px;

		transition-property:  max-width;
		transition-duration: 0.4s;
		transition-timing-function: ease-out;
		transition-delay: 1s;
	}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/modules/CheckinList.vue?b4abbb90